module.exports = "<div class=\"container\">\n  <div class=\"row\" *ngIf=\"!flag\">\n    <h2 >\n      You have successfully logged out.\n    </h2>\n    <br>\n    <a routerLink=\"/login\" class=\"btn btn-success\">Go Back To Login Page</a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/src/app/logout/logout.component.html
// module id = ../../../../../src/app/logout/logout.component.html
// module chunks = 1